export enum AppStatusTrackerSize {
    Small,
    Large
}
